import { useState, useEffect } from "react";
import axios from "axios";
import "../assets/styles/auth.css"
import RegistraionField from "../components/RegistrationField";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

function Signup() {
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
        document.title = "DCode | Signup";
      }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (password !== confirmPassword){
      setError("Passwords do not match!");
      return;
    }

    try{
      const response = await axios.post(`${BACKEND_URL}/auth/signup/`, {
        email,
        password,
      });

      setSuccess("Signup Successful!");
      setTimeout(() => {
        navigate("/login");
      }, 1500); // Redirect after 1.5 seconds
      // localStorage.setItem("Token", response.data.token);

    } catch (err) {
  console.error("Signup error:", err);
  if (err.response && err.response.data) {
    const errorData = err.response.data;
    setError(
      errorData.email?.[0] ||  // catches "User with this email already exists"
      errorData.password?.[0] ||
      errorData.non_field_errors?.[0] ||
      "Signup failed."
    );
  } else {
    setError("Signup failed. Please check network or server.");
  }
}
  }
    return(
      <>
        <Navbar />
      
        <section id="login">
       <div className="login-container" data-aos="flip-left">
      <h2 className="form-title">Sign Up</h2>
      {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}

      <form action="POST" className="login-form" onSubmit={handleSubmit}>
        <RegistraionField type="email" placeholder="Email address" icon="mail" value={email} onChange={(e) => setEmail(e.target.value)} />
        <RegistraionField type="password" placeholder="Password" icon="lock" value={password} onChange={(e) => setPassword(e.target.value)} />
        <RegistraionField type="password" placeholder="Confirm Password" icon="lock" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        
        
        <button type="submit" className="login-button">Sign Up</button>
      </form>
      <p className="signup-prompt">
       Already have an account? <a href="/login" className="signup-link">Log In</a>
      </p>
    </div>
 <Footer />
    </section>

     
    </>
    )
}

export default Signup;